/**
 * Appearance overrides scoped to the card-based auth widgets (`<SignIn>` /
 * `<SignUp>` on /login and /signup).
 *
 * Clerk's `rootBox` is the outermost wrapper shared by EVERY Clerk component
 * — including the sidebar `<UserButton>` — so the full-width white-card
 * styling the auth pages need must NOT live on the global ClerkProvider
 * appearance, or it bleeds into the avatar and renders it as a full-width
 * white pill. Instead the auth pages pass this object per-component; Clerk
 * deep-merges it over the provider appearance, so the card keeps all the
 * global theming (buttons, inputs, dividers) and only the `rootBox` here is
 * added on top.
 *
 * `w-full` on `rootBox` is load-bearing: without it the card collapses to its
 * intrinsic width instead of filling the 460px auth column. The rounded white
 * surface itself comes from `card`/`cardBox` (still global, since those slots
 * are card-specific and never touch the UserButton).
 *
 * Layout options use Clerk's `options` key (current SDK). Passkey, Google, and
 * Apple render automatically when enabled in the Clerk Dashboard — code only
 * controls placement and button style.
 */
export const authWidgetLayoutOptions = {
  socialButtonsPlacement: 'top',
  socialButtonsVariant: 'blockButton',
} as const;

export const authWidgetAppearance = {
  elements: {
    rootBox: 'w-full overflow-hidden rounded-2xl bg-white',
  },
  options: authWidgetLayoutOptions,
} as const;
